/* oddit-section-collection-grid — carousel navigation + autoplay */
(function () {
  var B = 'oddit-section-collection-grid';

  function init(section) {
    var track = section.querySelector('.' + B + '__track');
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    var dotsWrap = section.querySelector('.' + B + '__dots');
    if (!track) return;

    var hasNav = prev && next && dotsWrap;
    var step = 0;
    var maxScroll = 0;
    var pageStep = 0;
    var pageCount = 1;
    var autoplayTimer = null;
    var autoplayEnabled = section.hasAttribute('data-autoplay');
    var autoplaySpeed = (parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5) * 1000;

    function measure() {
      var cards = track.querySelectorAll('.' + B + '__card');
      step = cards.length > 1
        ? cards[1].offsetLeft - cards[0].offsetLeft
        : track.clientWidth;
      maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

      /* One dot per scrollable page, not per card. Pages are whole cards so
         they land on the scroll-snap positions. */
      var perPage = step > 0 ? Math.max(1, Math.floor(track.clientWidth / step)) : 1;
      pageStep = perPage * step;
      pageCount = Math.max(1, Math.ceil(cards.length / perPage));

      if (!hasNav) return;
      var allDots = dotsWrap.querySelectorAll('.' + B + '__dot');
      for (var i = 0; i < allDots.length; i++) {
        allDots[i].hidden = i >= pageCount;
      }
    }

    function sync() {
      if (!hasNav) return;
      var x = track.scrollLeft;
      var allDots = dotsWrap.querySelectorAll('.' + B + '__dot');
      var last = pageCount - 1;
      var index = x >= maxScroll - 1
        ? last
        : (pageStep > 0 ? Math.min(last, Math.round(x / pageStep)) : 0);

      for (var i = 0; i < allDots.length; i++) {
        if (i === index) allDots[i].setAttribute('aria-current', 'true');
        else allDots[i].removeAttribute('aria-current');
      }

      prev.disabled = x <= 1;
      next.disabled = x >= maxScroll - 1;
    }

    function advance() {
      if (track.scrollLeft >= maxScroll - 1) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: pageStep, behavior: 'smooth' });
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      autoplayTimer = setInterval(advance, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (hasNav) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -pageStep, behavior: 'smooth' });
        stopAutoplay();
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: pageStep, behavior: 'smooth' });
        stopAutoplay();
      });

      dotsWrap.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-carousel-dot]');
        if (!dot) return;
        var index = parseInt(dot.getAttribute('data-carousel-dot'), 10);
        track.scrollTo({
          left: Math.min(index * pageStep, maxScroll),
          behavior: 'smooth',
        });
        stopAutoplay();
      });
    }

    var frame = 0;
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        sync();
      });
    }, { passive: true });

    /* Pause autoplay on hover / focus */
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusout', startAutoplay);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () {
        measure();
        sync();
      }).observe(track);
    } else {
      window.addEventListener('resize', function () {
        measure();
        sync();
      });
    }

    measure();
    sync();
    startAutoplay();

    return { destroy: stopAutoplay };
  }

  /* Init all instances on page */
  var sections = document.querySelectorAll('.' + B);
  var instances = {};
  for (var i = 0; i < sections.length; i++) {
    var id = sections[i].id;
    if (id) instances[id] = init(sections[i]);
    else init(sections[i]);
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.' + B);
    if (el) {
      var id = el.id;
      if (id) instances[id] = init(el);
      else init(el);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('.' + B);
    if (el && el.id && instances[el.id]) {
      instances[el.id].destroy();
      delete instances[el.id];
    }
  });
})();